<template>
	<div class="intro-container" :class="[mode]">
		<div class="wider-wrapper">
			<div class="intro-container-inner">
				<CmsBreadcrumbs v-if="page?.breadcrumbs" :items="page.breadcrumbs" />
				<slot name="h1" />
			</div>
		</div>
	</div>
</template>

<script setup>
	const props = defineProps(['page', 'mode']);
</script>

<style lang="less" scoped>
	.cart, .auth, .webshop{
		.bc{display: none!important;}
	}
	.cart{background: #fff!important;}
</style>